var map = {
	"./CIA经停机场.png": 49272,
	"./军事设施.png": 87079,
	"./军营.png": 426,
	"./未知基地.png": 49679,
	"./机场.png": 25542,
	"./浮空器.png": 42472,
	"./海军基地.png": 4922,
	"./港口.png": 86576,
	"./睡莲.png": 7195,
	"./空军基地.png": 78545,
	"./陆军基地.png": 56653,
	"./雷达站.png": 98504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22109;